// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"ad920659","205":"2a037347","242":"797cf72e","279":"239ad44a","371":"7b30ea71","580":"875e53d9","583":"15c43d2d"}[chunkId] + ".chunk.js";
};